import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import {api} from './api.js';

const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';

export default new Vuex.Store({
  state: {
    isLoggedIn: sessionStorage.getItem('token'),
    token: sessionStorage.getItem('token'),
    name: sessionStorage.getItem('name'),
    role: sessionStorage.getItem('role'),
    id: sessionStorage.getItem('id'),
  },
  mutations: {
    [LOGIN](state) {
      state.isLoggedIn = true;
      state.token = sessionStorage.getItem('token');
      state.name = sessionStorage.getItem('name');
      state.role = sessionStorage.getItem('role');
      state.id = sessionStorage.getItem('id');
    },
    [LOGOUT](state) {
      state.isLoggedIn = false;
      state.token = '';
      state.name = '';
      state.role = '';
      state.id = '';
    }
  },
  actions: {
    login (context, credentials) {
      return api.post('/auth', {
        username: credentials.username,
        password: credentials.password
      }).then((response) => {
        window.sessionStorage.setItem('token', response.data.token);
        window.sessionStorage.setItem('name', response.data.name);
        window.sessionStorage.setItem('role', response.data.role);
        window.sessionStorage.setItem('id', response.data._id);
        context.commit(LOGIN);
      });
    },

    logout (context) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('name');
      sessionStorage.removeItem('role');
      sessionStorage.removeItem('id');
      context.commit(LOGOUT);
    }
  }
});
